



















import { Component, Vue, Prop } from 'vue-property-decorator';
import { ScreenText } from '@/lang/ScreenText';
import MobileDiscountTooltip from './MobileDiscountTooltip.vue';
import discountStore from '@/store/modules/discounts';

@Component({
  components: {
    MobileDiscountTooltip
  }
})
export default class SessionDiscountBadge extends Vue {
  @Prop({ type: String, required: true }) discountAmount!: string;
  @Prop({ type: Boolean, required: true }) isMultiParticipantDiscount!: boolean;
  @Prop({ type: Boolean, required: true }) isMobile!: boolean;

  private screenText: ScreenText = new ScreenText();

  get formattedDiscountAmount(): string {
    return `${this.currentDiscountName} (${this.discountAmount} ${this.screenText.getScreenText(
      'DISCOUNT_LABEL_OFF'
    )})`;
  }

  /**
   * Computed property that returns the name of the current discount based on the type of discount.
   * @returns {string} The name of the current discount.
   */
  get currentDiscountName(): string {
    return (
      (this.isMultiParticipantDiscount
        ? discountStore.multiParticipantDiscountData &&
          discountStore.multiParticipantDiscountData.name
        : discountStore.earlyDiscountData && discountStore.earlyDiscountData.name) || ''
    );
  }

  /**
   * Computed property that returns the description of the current discount based on the type of discount.
   * @returns {string} The description of the current discount.
   */
  get currentDiscountDescription(): string {
    return (
      (this.isMultiParticipantDiscount
        ? discountStore.multiParticipantDiscountData &&
          discountStore.multiParticipantDiscountData.description
        : discountStore.earlyDiscountData && discountStore.earlyDiscountData.description) || ''
    );
  }
}
